export default "__VITE_ASSET__DXg3n4D8__"